import classNames from 'classnames';
import type { FC } from 'react';
import React from 'react';

interface SvgIconBaseProps {
    path: string;
    className?: string;
}

export const SvgIconBase: FC<React.PropsWithChildren<SvgIconBaseProps>> = props => {
    const { path, className } = props;

    return (
        <span className={classNames('SvgIcon', className)}>
            <svg>
                <use xlinkHref={path} />
            </svg>
        </span>
    );
};
